import history from '../../util/history'

const showDetailView = hotel => {
  const id = hotel.id
  history.push(`/hotels/${id}/details`)
  return true
}

export default showDetailView
